import { apiClient } from "@/api/client";

/**
 * Descarga cualquier archivo binario servido por el backend (Excel, Word, PDF...)
 * a través del cliente Axios autenticado (para que viaje el header
 * `Authorization`, algo que un simple `<a href="...">` no podría hacer) y
 * dispara la descarga en el navegador. Generaliza el mismo patrón que ya
 * usaba `downloadReportCsv` en `api/reports.ts`, sin atarlo a CSV/reportes.
 */
export async function downloadFile(path: string, filename: string, params?: Record<string, string | number | undefined>): Promise<void> {
  const response = await apiClient.get(path, { params, responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
